import { Operating } from '../../../models/operating';
import { concatMap, filter, first, map, switchMap } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr'; // Alert message using NGX toastr
import { of, Subscription } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { AuthService } from 'src/app/shared/service/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { FirePracticalAssessmentService } from 'src/app/services/fire-practical-assessment-services/fire-practical-assessment.service';

@Component({
  selector: 'app-operating-assessment-list',
  templateUrl: './operating-assessment-list.component.html',
  styleUrls: ['./operating-assessment-list.component.scss'],
})
export class OperatingAssessmentListComponent implements OnInit, OnDestroy {
  constructor(
    public fireOperatingAssessment: FirePracticalAssessmentService,
    public toastr: ToastrService,
    private db: AngularFireDatabase,
    private firestoredb: AngularFirestore,
    private authService: AuthService
  ) {}
  p = 1; // Setup up pagination variable

  Assessment: Operating[]; // Save assessment data in Assessment's array.
  hideWhenNoAssessment = false; // Hide assessment data table when no assessment.
  noData = false; // Showing No Assessment Message, when no assessment in database.
  itemKeys = [];
  data = [];
  assessmentKey!: any;
  readAssessmenListSub: Subscription;
  @ViewChild('new-assessment') assessmentButton: HTMLButtonElement;

  // K-Andre function to get itemKey and data for view.
  getItemKeys() {
    this.firestoredb.collection('users').doc(this.authService.userData?.uid).get().toPromise().then((payload: any) => {
      const assessmentList = this.fireOperatingAssessment.readAssessmentsListOperating();
  
      const operatingAssessmentListAdmin = this.firestoredb
        .collection('operating-assessment-inputs', (ref) =>
          ref.where('adminCode.value', '==', this.authService.adminCode?.value || this.authService.adminCode || '')
        )
        .snapshotChanges();
  
      const formerOperatingAssessmentListAdmin = this.firestoredb
        .collection('operating-assessment-inputs', (ref) =>
          ref.where('adminCode', '==', this.authService.adminCode?.value || this.authService.adminCode || '')
        )
        .snapshotChanges();
  
      if (this.authService.adminCode && this.authService.isAdmin) {
        operatingAssessmentListAdmin
          .pipe(
            map((actions) =>
              actions.map((a) => {
                const data: any = a.payload.doc.data();
                return {
                  ...data,
                  key: a.payload.doc.id,
                }
              })
            ),
            switchMap(data => formerOperatingAssessmentListAdmin.pipe(
              map((actions) => {
                const results = actions.map((a) => {
                  const data: any = a.payload.doc.data();
                  return {
                    ...data,
                    key: a.payload.doc.id,
                  }
                }).concat(data);
                return results;
              }
              ))
            ))
          .subscribe((data) => {
            this.itemKeys = data.map((item) => item.key);
            this.data = data;
            return this.itemKeys;
          });
      } else {
        assessmentList
          .snapshotChanges()
          .pipe(
            map((actions) =>
              actions.map((a) => ({
                key: a.payload.doc.id,
                ...a.payload.doc.data(),
              }))
            )
          )
          .subscribe((data: any[]) => {
            this.itemKeys = data.map((item) => item.key);
            this.data = data;
            return this.itemKeys;
          });
      }
    })

  }

  freemiumUser() {
    this.fireOperatingAssessment
      .readAssessmentsListOperating()
      .valueChanges()
      .subscribe((data) => {
        console.log('Here is the length' + data.length);
        if (data.length >= 1) {
          (<HTMLInputElement>(
            document.getElementById('new-assessment')
          )).style.display = 'none';
        } else {
          (<HTMLInputElement>(
            document.getElementById('new-assessment')
          )).style.display = 'block';
        }
      });
    // if (assessmentList.query.) { #check if assessmentList is > 1
    //   disable addAssessment button
    // }
  }
  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.getItemKeys();
    // this.freemiumUser()// Initialize assessments list when component is ready
  }

  ngOnDestroy() {
    if (this.readAssessmenListSub) {
      this.readAssessmenListSub.unsubscribe();
    }
  }
  //Please see how to get this to work
  deleteAssessment(assessment) {
    if (window.confirm('Are you sure you want to delete this assessment?')) {
      // Asking from user before Deleting assessment data.
      this.fireOperatingAssessment.DeleteAssessment(); // Using Delete student API to delete assessment.
      this.toastr.success(assessment.busiName + ' successfully deleted'); // Alert message will show up when student successfully deleted.
    }
  }
}
